import React from "react";

export default function Policy({ VenuesDetails }) {
  return (
    <div className="details-section">
      <h4>Policy</h4>

      <div className="row">
        <div className="col-md-6">
          <h5>Cancellation Policy</h5>
          <div
            dangerouslySetInnerHTML={{ __html: VenuesDetails?.policy }}
          ></div>
        </div>
      </div>
    </div>
  );
}
